var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstituteTutorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9966 43V18.3651C13.9966 15.6245 13.9966 14.2542 14.4857 13.1048C14.9749 11.9555 15.8734 11.2145 17.6705 9.73248L21.8336 6.29936C22.884 5.43313 23.4092 5 23.9966 5C24.584 5 25.1092 5.43313 26.1596 6.29936L30.3226 9.73248C32.1198 11.2145 33.0182 11.9555 33.5074 13.1048C33.9966 14.2542 33.9966 15.6245 33.9966 18.3651V43",
    stroke: "#292D35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.9082H24.0184",
    stroke: "#292D35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0029 42.9989V28.0215C42.0029 22.1421 39.4845 21.6662 34.0029 19.9082",
    stroke: "#292D35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 42.9989V28.0215C6 22.1421 8.51832 21.6662 14 19.9082",
    stroke: "#292D35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00293 42.998H44.0029",
    stroke: "#292D35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42.9988V32.7363",
    stroke: "#292D35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituteTutorLogo);
export default __webpack_public_path__ + "static/media/Institute Tutor Logo.158c07f955151b8adcdd72fd9593f887.svg";
export { ForwardRef as ReactComponent };